/**
 * Main CTA Banner Component
 * 
 * Handles initialization and interaction for the main CTA banner
 */
export class MainCTABanner {
  private element: HTMLElement;
  private button: HTMLElement | null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.button = this.element.querySelector('.pill-button');
    this.init();
  }

  private init(): void {
    if (this.button) {
      this.button.addEventListener('click', this.handleButtonClick.bind(this));
    }
  }

  /**
   * Handle CTA button click
   * @param {Event} event - Click event
   */
  private handleButtonClick(event: Event): void {
    // Custom click handling can be added here
    // For example, tracking analytics events or showing a modal
    
    // Example: Emit custom event that can be listened to by parent applications
    const customEvent = new CustomEvent('main-cta-clicked', {
      bubbles: true,
      detail: {
        text: this.button?.querySelector('.pill-button__label')?.textContent
      }
    });
    
    this.element.dispatchEvent(customEvent);
  }
}

// Initialize all main CTA banners on the page
document.addEventListener('DOMContentLoaded', () => {
  const banners = document.querySelectorAll('.main-cta-banner');
  banners.forEach(banner => new MainCTABanner(banner as HTMLElement));
});